import { useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import api from "@/lib/api";
import { STATUS_STYLE } from "@/lib/branch";

export const DownlineList = ({ root = "" }) => {
  const [level, setLevel] = useState(0);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [applied, setApplied] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/network/downline", { params: { level, status, q: applied, page, root } }).then(({ data }) => setData(data)).catch(() => setData({ members: [], total: 0, pages: 1 }));
  }, [level, status, applied, page, root]);

  return (
    <div className="space-y-3" data-testid="downline-list">
      <form onSubmit={(e) => { e.preventDefault(); setPage(1); setApplied(q); }} className="flex flex-wrap gap-2">
        <div className="relative"><Search className="w-4 h-4 absolute left-2.5 top-2.5 text-[#94A3B8]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Member, ID or branch code" className="input-soft pl-8 py-2 text-sm w-56" data-testid="downline-search-input" /></div>
        <select value={level} onChange={(e) => { setPage(1); setLevel(Number(e.target.value)); }} className="input-soft py-2 text-sm w-32" data-testid="downline-level-filter">
          <option value={0}>All levels</option>{[1, 2, 3, 4, 5, 6, 7, 8].map((l) => <option key={l} value={l}>Level {l}</option>)}
        </select>
        <select value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }} className="input-soft py-2 text-sm w-32" data-testid="downline-status-filter">
          <option value="">All status</option><option value="active">Active</option><option value="pending">Pending</option>
        </select>
        <button className="btn-primary text-sm" data-testid="downline-search-btn">Search</button>
      </form>
      {!data ? <div className="flex items-center gap-2 text-sm text-[#94A3B8]"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div> : (
        <div className="overflow-x-auto bg-white border border-[#F1F5F9] rounded-2xl">
          <table className="w-full text-sm">
            <thead className="bg-[#FEF2F2] text-[#7F1D1D] text-xs uppercase"><tr>{["Level", "Member", "ID", "Joined via", "Status", "Direct", "Team", "Joined"].map((h) => <th key={h} className="text-left px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>
              {data.members.length === 0 && <tr><td colSpan={8} className="text-center py-8 text-[#94A3B8]" data-testid="downline-empty">No members match.</td></tr>}
              {data.members.map((m) => (
                <tr key={m.id} className="border-t border-[#F1F5F9]" data-testid={`downline-row-${m.user_code}`}>
                  <td className="px-3 py-2 font-numbers">L{m.level}</td><td className="px-3 py-2 font-medium text-[#7F1D1D]">{m.name}</td>
                  <td className="px-3 py-2 font-numbers">{m.user_code}</td><td className="px-3 py-2 font-mono text-xs">{m.sponsor_branch_code || "—"}</td>
                  <td className="px-3 py-2"><span className={`text-[10px] px-1.5 py-0.5 rounded border ${m.is_active ? STATUS_STYLE.active : STATUS_STYLE.pending_payment}`}>{m.is_active ? "Active" : "Pending"}</span></td>
                  <td className="px-3 py-2 font-numbers">{m.direct_referrals}</td><td className="px-3 py-2 font-numbers">{m.team_size}</td>
                  <td className="px-3 py-2 text-xs">{m.joined_at ? new Date(m.joined_at).toLocaleDateString("en-IN") : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.pages > 1 && (
            <div className="flex items-center gap-2 text-xs p-3">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-2 py-1 rounded border disabled:opacity-40" data-testid="downline-prev">Prev</button>
              <span>Page {page} / {data.pages} · {data.total}</span>
              <button disabled={page >= data.pages} onClick={() => setPage(page + 1)} className="px-2 py-1 rounded border disabled:opacity-40" data-testid="downline-next">Next</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
